'use strict';

import React from 'react';
import flux from 'utils/flux';
import Immutable from 'immutable';
import QuotaWarning from 'components/quota/quotaWarning';
import InstantDownloadItem from 'components/modals/instantDownloadItem';
import store from 'store';

var InstantDownloadModal = React.createClass({

    displayName: 'InstantDownloadModal',

    propTypes: {
        media: React.PropTypes.object
    },

    toggleCheck(fileId, item, e) {
        e.preventDefault();
        flux.getActions('modals').toggleDownload(fileId);
    },

    handleDownload(e) {
        e.preventDefault();
        flux.getActions('modals').generateDownload();
    },

    handleOnSubmit(e) {
        e.preventDefault();
        const asset = this.props.media.toJS();
        let params = {};

        asset.files.forEach( file => {
            if ( !file._selected ) {
                return;
            }

            if ( !params[ asset.id ] ) {
                params[ asset.id ] = file.key;
            }
            else {
                params[ asset.id ] += `,${file.key}`;
            }
        });

        flux.getStore('media').checkQuota( params ).then( response => {
            const { quotaExceeded } = flux.getStore('media').getState();

            if ( quotaExceeded ) {
                return false;
            }

            this.refs.download.getDOMNode().submit();

            asset.requires_watermark && flux.getActions('modals').openWatermarkModal( Immutable.List([ asset ]) );
            flux.getActions('modals').closeModals();
        });
    },

    render() {
        if ( !this.props.media ) {
            return false;
        }

        var mediaboxToken = store.get('mediabox_token');
        var totalSelected = flux.getStore('modals').getSelectedInstantDownloadItems();
        const { quotaExceeded } = this.props;

        return(
            <div>
                <h4>{flux.t('instant_download')}</h4>
                <form ref="download" onSubmit={this.handleOnSubmit} action={window.config.baseUrl + '/download'} method="post">
                <input type="hidden" name="token" value={mediaboxToken} />
                    <InstantDownloadItem media={this.props.media} toggleCheck={this.toggleCheck} />
                    <div className="instantdownload__footer">
                            <QuotaWarning />
                            <button type="submit" disabled={totalSelected.length === 0 || quotaExceeded} className="btn btn-border selection__download submit__instantdownload">
                                <i className="download" />
                                {flux.t('download')}
                            </button>
                        </div>
                </form>
            </div >
        );
    }
});

module.exports = InstantDownloadModal;



// WEBPACK FOOTER //
// ./app/components/modals/instantDownloadModal.jsx